import React from 'react'

import {
  Navigate,
  useLocation,
} from 'react-router-dom'

import { URLBuilder } from '@termly-web/common'


export default function LoginRedirect() {
  const { search } = useLocation()

  // `URLBuilder.loginURL()` takes a query object and returns a string, but
  // passing `search` through it re-normalizes the query. That same string
  // later feeds `/auth/login`, where the backend measures it against a
  // 1024-char cap. Keeping `search` verbatim in a location object avoids that.
  const loginLocation = {
    pathname: URLBuilder.loginURL(),
    search,
  }

  return (
    <Navigate
      to={ loginLocation }
    />
  )
}
